window.application.register("toggle", 
	class extends Stimulus.Controller {

		// <div 
		// data-controller="toggle"
		// class="relative">
		// 	<div 
		// 	data-action="click->toggle#open"
		// 	class="tz-button">
		// 		<i class="fa far fa-chevron-down mr-2"></i>Tier 1
		// 	</div>
		// 	<div 
		// 	data-target="toggle.toggled"
		// 	class="absolute left-1/2 bottom-0"
		// 	data-transition-enter="transition ease-out duration-100" 
		// 	data-transition-enter-start="transform opacity-0 scale-95" 
		// 	data-transition-enter-end="transform opacity-100 scale-100" 
		// 	data-transition-leave="transition ease-in duration-100" 
		// 	data-transition-leave-start="transform opacity-100 scale-100" 
		// 	data-transition-leave-end="transform opacity-0 scale-95">
		// 			<div class="bg-gray-900 flex flex-col text-white min-w-150px max-h-300px absolute transform -translate-x-1/2 text-center mt-3 rounded-md p-3">
		// 				<%for(let index in tiers){%>
		//					<a 
		//					data-action="toggle#setLabel toggle#close"
		//					data-toggle-label="<%=tiers[index].name%>"
		//					class="rounded-sm hover:bg-gray-800 text-white text-xs p-2 hover:text-white hover:no-underline"><%=tiers[index].name%></a>
		// 				<%}%>
		// 			</div>
		// 	</div>
		// </div>

		static get targets() {
		  return [ "toggled", "label", "openIcon", "closeIcon"]
		}

		connect(){
			this.element[this.identifier] = this;
			if(this.isOpen){
				this.open();
			}else{
				this.close();
			}
			if(this.data.get('clickoutClose') == "false"){

			}else{
				document.querySelector('html').addEventListener('click', this.windowClose.bind(this));	
			}
		}

		windowClose(e){
			if(!window.utils.isDescendant(this.element, e.target)){
				this.close();
			}
		}
		
		set isOpen(val){
			this.data.set('isOpen', val);
			this.render();
		}

		get isOpen(){
			return this.data.get('isOpen') == "true"?true:false;
		}

		open(){
			this.isOpen = true;
			// console.log('try open');
		}

		close(e){
			this.isOpen = false;
			// console.log('try close');
			// console.log(this.isOpen);
		}

		setLabel(e){
			//set via event or value
			if(this.labelTarget && e.currentTarget && e.currentTarget.dataset && e.currentTarget.dataset.toggleLabel){
				this.labelTarget.innerHTML = e.currentTarget.dataset.toggleLabel;
			}else if(this.labelTarget && e){
				this.labelTarget.innerHTML = e;
			}
		}
		toggle(){
			if(this.isOpen){
				// console.log('toggle close');
				// console.log(this.isOpen);
				this.close();
			}else{
				// console.log('toggle open');
				this.open();
			}
		}

		render(){
			if(!this.isOpen){
				if(this.data.get('toggledIds')){
					var toggledIds = this.data.get('toggledIds').split(' ');
					for(let index in toggledIds){
						el.leave(document.getElementById(toggledIds[index]));	
					}
				}
				if(this.hasToggledTarget){
					el.leave(this.toggledTarget);	
				}

				if(this.hasOpenIconTarget){
					this.openIconTarget.classList.add('hidden');
				}
				if(this.hasCloseIconTarget){
					this.closeIconTarget.classList.remove('hidden');
				}
			}else{
				if(this.data.get('toggledIds')){
					var toggledIds = this.data.get('toggledIds').split(' ');
					for(let index in toggledIds){
						el.enter(document.getElementById(toggledIds[index]));	
					}
				}
				if(this.hasToggledTarget){
					el.enter(this.toggledTarget);	
				}
				if(this.hasOpenIconTarget){
					this.openIconTarget.classList.remove('hidden');
				}
				if(this.hasCloseIconTarget){
					this.closeIconTarget.classList.add('hidden');
				}
			}
		}

		disconnect(){
			try{
				this.tearDown();
			}catch(err){}
		}

		tearDown(){
			document.querySelector('html').removeEventListener('click', this.windowClose.bind(this));
		}
	}
)

//https://www.w3schools.com/howto/howto_css_dropup.asp#:~:text=Use%20any%20element%20to%20open,dropup%20menu%20correctly%20with%20CSS.